<template>
  <div class="text-primary l-h-22 grey">
    <p>
      There are 3 main phases of clinical trials during which a drug/medical device/a new treatment
      method is tested to see if it is effective enough for public use. These phases are monitored
      by FDA and will need its approval in the final stage in order for the new product to go out
      to the market.
    </p>
    <h5>Phase 1</h5>
    <p>
      The purpose of Phase 1 is to ensure that the treatment is safe and can be used in humans.
      During this phase the following points are covered:
    </p>
    <ol class="ml-4">
      <li>
        The highest dose of the drug that is safe
      </li>
      <li>
        Possible side effects at different doses
      </li>
      <li>
        The way the body gets rid of the drug
      </li>
      <li>
        Any positive effects of the treatment
      </li>
    </ol>
    <p>
      Only a few people are recruited to test the treatment in this phase.
      At the end of Phase 1, the results are collected and analyzed then submitted to the FDA.
      If they are approved, you can proceed to Phase 2.
    </p>
    <h5>Phase 2</h5>
    <p>
      During Phase 2, the effectiveness of the drug is determined
      as well as the right dosage to be used by patients. At this stage, a
      larger number of volunteers are involved in the treatment testing process.
    </p>
    <p>
      Different treatment groups are formed and while some get different doses of the new drug,
      others (included in a control group) receive either the standard type of treatment
      (if there is already one) or a placebo.
    </p>
    <p>
      Eventually, the results are compared and if the new treatment happens to be ineffective
      or gives the same results as the existing one, or worse, if it accelerates the
      disease development, the FDA will not give permission for Phase 3.
    </p>
    <h5>Phase 3</h5>
    <p>
      Phase 3 clinical trials usually include several hundred volunteers and can be
      carried out across the whole country or even worldwide. Again, a control group is
      formed that receives a placebo while other treatment groups take the actual drug.
      The difference between Phase 2 and Phase 3 is that the latter involves a wider range
      of people at various stages of the disease.
    </p>
    <p>
      When the results are ready, the health of the patients from different treatment
      groups is compared to that of the control group patients. If the results show no positive
      effects or even worse if they have had a negative effect on the patients’ health,
      the FDA might not grant its permission to apply for a New Drug Application (NDA).
      The latter is a submission to the FDA for a final review and if approved,
      the drug will go on sale in the market.
    </p>
    <h5> Phase 4</h5>
    <p>
      This phase is optional and not always carried out. After the FDA approves the new
      product, it enters the phase of Clinical Trial/Post-Market Surveillance/Report Adverse Events
      phase. While on the market, the FDA keeps an eye on the treatment to monitor any possible
      adverse effects it can have.
    </p>
    <p>
      There can also be Phase 0 trials before Phase 1 starts. These are usually optional,
      involving very few people (up to 15) and testing low doses of the drug. Phase 0 is not
      common in drug testing and when implemented, is only aimed to see the way the drug acts in
      the human body. In this phase the patients won’t feel any positive changes or effects of
      the drug. It will also be quite safe for the volunteers.
    </p>
    <p class="card-ctx">
      At STATECS, our experts will support you across all of these phases by providing you with
      the latest technologies and useful advice throughout the overall process. We have the right
      specialists with the corresponding skills for every phase. They will help you determine your
      goals more precisely while ensuring data safety across all stages. Due to our
      client-oriented approach and trust-based collaboration with our customers, we are able to
      deliver the best results at affordable prices, maintaining quality and ethical standards.
    </p>
    <b-card-title
      class="title text-primary font-weight-bold f-s-22 l-s-0"
      style="left: 47%"
    >
      {{ modalItem.title }}
    </b-card-title>
  </div>
</template>

<script>
export default {
  name: 'ClinicalTrialPhases',
  props: {
    modalItem: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
